import { TaxCategoryType } from './types'

interface TaxCategoryProps {
  tax_category: TaxCategoryType
}

export default function TaxCategory({ tax_category }: TaxCategoryProps) {
  return (
    <div>
      <p className="my-5">
        <strong className="block font-medium mb-1">Name:</strong>
        {tax_category.name?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Code:</strong>
        {tax_category.code?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Status:</strong>
        {tax_category.status?.toString()}
      </p>
    </div>
  )
}
